module.exports = {
  "level1": {
    "name": "Ekte navn",
    "idcard": "Dokumenttype:",
    "address": "Nåværende adresse",
    "bank_number": "Bankkontonummer",
    "wc": "Bekreft",
    "name_nodata": "Navn kan ikke være tomt",
    "id_card_nodata": "Dokumentnummer kan ikke være tomt",
    "address_nodata": "Adresse kan ikke være tom",
    "bank_number_nodata": "Bankkontonummer kan ikke være tomt",
    "input-username": "Vennligst skriv inn ekte navn",
    "zjhm": "Dokumentnummer",
    "input-idcard": "Vennligst skriv inn dokumentnummer",
    "input-address": "Vennligst skriv inn adresse",
    "zjlx": "Dokumenttype",
    "qxzzjlx": "Vennligst velg dokumenttype",
    "sfz": "Identitetskort",
    "hz": "Pass",
    "jsz": "Førerkort",
    "lxz": "Studieopphold",
    "zfbzh": "Alipay-konto",
    "qsrzfbzh": "Vennligst skriv inn Alipay-konto",
    "khh": "Bank",
    "qsrkhh": "Vennligst skriv inn bank",
    "yhkh": "Bankkontonummer",
    "qsryhkh": "Vennligst skriv inn bankkontonummer",
    "zfzh": "Betalingskonto",
    "qxzzfzh": "Vennligst velg betalingskonto",
    "gjlb": "Landliste",
    "qxzgjlb": "Vennligst velg land/region"
  },
  "my": {
    "bindphone": "Bind mobiltelefon",
    "gqrcode": "Skann QR-koden nedenfor eller skriv inn promotorkoden for å bekrefte registreringen",
    "mqrcode": "Min QR-kode",
    "as": "Innstillinger",
    "pc": "Grunnleggende verifisering",
    "ac": "Avansert verifisering",
    "smrz": "Identitetsverifisering",
    "sfyz": "Identitetsbekreftelse",
    "mm": "Mine midler",
    "ms": "Jeg vil dele",
    "me": "Mine inntekter",
    "zsr": "Total inntekt",
    "mp": "Min promotering",
    "yqhy": "Inviter venner",
    "ar": "Rekord",
    "hc": "Hjelpesenter",
    "nodata": "Ingen data tilgjengelig",
    "med": "Inntektsdetaljer",
    "aes": "Total inntekt (USDT)",
    "one": "Første generasjon",
    "two": "Andre generasjon",
    "three": "Tredje generasjon",
    "four": "Fjerde generasjon",
    "ones": "Antall første generasjon",
    "twos": "Antall andre generasjon",
    "threes": "Antall tredje generasjon",
    "fours": "Antall fjerde generasjon",
    "promotion": "Antall promoteringer",
    "customers": "Mine inntekter",
    "total": "Totalt (i går)",
    "usdt": "USDT",
    "wdzc": "Mine eiendeler",
    "wdzc1": "Mine eiendeler",
    "wyfx": "Jeg vil dele",
    "wdsy": "Mine inntekter",
    "wdtg": "Min promotering",
    "zhjl": "Kontoopptegnelser",
    "fbjl": "Valutaopptegnelser",
    "zxkf": "Kontakt kundeservice",
    "wdxx": "Mine meldinger",
    "mnzh": "Simuleringskonto",
    "mnzhcg": "Simuleringskonto opprettet!"
  },
  "footer": {
    "home": "Hjem",
    "quotation": "Marked",
    "currency": "Valutahandel",
    "lever": "Kontraktshandel",
    "assets": "Eiendeler",
    "my": "Min",
    "lc": "Inntekt på beholdning"
  },
 "index": {
    "wdzc": "Mine eiendeler (USDT)",
    "xsbk": "Nybegynner må lese",
    "dlhkck": "Logg inn for å se",
    "dl": "Logg inn for å se",
    "zxkf": "Kontakt kundeservice",
    "function": "Funksjonstjenester",
    "legal": "Valuta handel",
    "legaltxt": "Kjøp digitale eiendeler med fiat-valuta",
    "levertxt": "Investeringer mange ganger mer enn opprinnelige midler",
    "c2c": "C2C handel",
    "c2ctxt": "Toveis handel, sikringshandel",
    "increase": "Økningsliste",
    "innovate": "Innovasjonsområde",
    "myshop": "Min butikk",
    "order": "Ordrehåndtering",
    "myc2c": "Min C2C handel",
    "usercenter": "Personlig senter",
    "myshare": "Min delingslenke",
    "releasec2c": "Publiser C2C",
    "language": "Språkbytte",
    "security": "Sikkerhetssenter",
    "pay": "Betalingsmetode",
    "bindaddress": "Bind uttaksadresse",
    "address": "Uttaksadresse",
    "aboutus": "Om oss",
    "logout": "Logg ut",
    "vol": "24H volum",
    "jc": "JC bytte BEAU",
    "kjcb": "Rask innskudd",
    "zcbz": "BTC, USDT..."
  },
  "transaction": {
    "buy": "Kjøp",
    "sell": "Selg",
    "pwd": "Handelspassord",
    "inputpass": "Skriv inn handelspassord",
    "inputnum": "Skriv inn mengde",
    "limit": "Grensepris",
    "avaiable": "Tilgjengelig",
    "turnover": "Handelsbeløp",
    "handicap": "Marked",
    "number": "Mengde",
    "nonumber": "Ufullført mengde",
    "numbered": "Fullført mengde",
    "price": "Pris",
    "marketprice": "Markedspris",
    "cancel": "Avbryt",
    "total": "Totalt for hele nettstedet",
    "time": "Tid",
    "nomore": "Ingen flere tilgjengelige",
    "nodata": "Ingen opptegnelser tilgjengelige",
    "getmore": "Last inn mer",
    "mycommission": "Mine oppdrag",
    "currentbuy": "Nåværende oppdrag (Kjøp)",
    "currentsell": "Nåværende oppdrag (Selg)",
    "his": "Historiske oppdrag (Fullført)",
    "currency": "Valuta",
    "option": "Handling",
    "wtime": "Fullføringstid",
    "wnumber": "Fullført mengde",
    "wprice": "Fullført pris"
  },
  "mk": {
    "high": "Høy",
    "low": "Lav",
    "vol": "24H volum",
    "newPrice": "Siste pris",
    "product": "Produkt",
    "name": "Navn",
    "rank": "Økningsliste"
  },
 "deals": {
    "issue_time": "Utgivelsestid",
    "issue_number": "Utgivelsesvolum",
    "white_book": "Whitepaper",
    "weburl": "Offisiell nettside",
    "video_url": "Videoinnledning",
    "introduction": "Introduksjon",
    "onhand": "1 hånd er lik",
    "position": "Nåværende posisjon",
    "leverorder": "Giring ordre",
    "leverposition": "Giring posisjon",
    "inputprice": "Skriv inn pris",
    "inputmul": "Skriv inn multiplikator",
    "selectmul": "Velg multiplikator",
    "onehand": "1 hånd er lik",
    "hand": "Handelsmengde",
    "marketval": "Kontraktsverdi",
    "bond": "Margin",
    "service": "Serviceavgift",
    "balance": "Saldo",
    "type": "Type",
    "risk": "Risikoandel",
    "total": "Total gevinst/tap:",
    "onekey": "Lukk posisjon med ett klikk",
    "makemore": "(Kjøp)",
    "makeless": "(Selg)",
    "current": "Nåværende oppdrag",
    "all": "Alle",
    "weing": "Ordre i behandling",
    "tding": "Handel pågår",
    "ping": "Lukking pågår",
    "pied": "Lukket",
    "ceiled": "Avbrutt",
    "weprice": "Ordrepris",
    "oprice": "Inngangspris",
    "nowprice": "Nåværende pris",
    "zyprice": "Take profit pris",
    "zsprice": "Stop loss pris",
    "canbond": "Tilgjengelig margin",
    "optime": "Inngangstid",
    "pgtime": "Lukketid",
    "znum": "Verdi i mengde",
    "gprice": "Overnattingsgebyr",
    "pcang": "Lukk posisjon",
    "revoke": "Avbryt ordre",
    "fee": "Gebyr",
    "you": "Handle til beste nåværende pris"
  },
  "assets": {
    "bzxz": "Valutavalget",
    "copy": "Kopier",
    "currency": "Valuta",
    "lever": "Kontrakt",
    "legal": "Fiat",
    "curAccount": "Valutakonto",
    "total": "Eiendelverdi (USDT)",
    "leverAccount": "Kontraktskonto",
    "legalAccount": "Fiatkonto",
    "avaiable": "Tilgjengelig",
    "lock": "Frosset",
    "conversion": "Verdi",
    "exact": "Handelskonto",
    "transfer": "Overføring",
    "num": "Mengde",
    "time": "Tid",
    "record": "Opptegnelse",
    "caidata": "Finansopptegnelser",
    "from": "Fra",
    "to": "Til",
    "transnum": "Overføringsmengde",
    "all": "Alle",
    "canuse": "Tilgjengelig",
    "pmin": "Vennligst skriv inn minimum overføringsmengde",
    "cmoney": "Innskudd",
    "tmoney": "Uttak",
    "caddress": "Innskuddsadresse",
    "copyaddress": "Kopier adresse",
    "a01": "Vennligst ikke innskudd noen ikke-",
    "a02": "eiendeler til ovennevnte adresse,",
    "a03": "ellers vil eiendelene ikke kunne gjenopprettes.",
    "a04": "Innskudd støtter kun metoden 'simple send', innskudd ved bruk av andre metoder kan midlertidig ikke krediteres, vi ber om forståelse.",
    "a05": "Etter innskudd til ovennevnte adresse, kreves bekreftelse fra hele nettverksnoden, 1 nettverksbekreftelse før beløpet krediteres, 6 nettverksbekreftelser for uttak.",
    "a06": "Minimum innskuddsbeløp:",
    "a07": "Innskudd under minimumsbeløpet vil ikke bli kreditert og kan ikke tilbakebetales.",
    "a08": "Din innskuddsadresse vil ikke endres ofte, og kan brukes til gjentatte innskudd; hvis det er endringer, vil vi prøve å informere deg via nettsideannonse eller e-post.",
    "a09": "Vennligst bekreft at datamaskinen og nettleseren er sikre for å hindre at informasjon blir endret eller lekket.",
    "taddress": "Uttaksadresse",
    "taddressm": "Vennligst skriv inn uttaksadresse",
    "padd": "Skriv inn eller hold nede for å lime inn adresse",
    "rate": "Gebyr",
    "dnum": "Beløp som kommer frem",
    "more": "Last inn mer",
    "nodata": "Ingen opptegnelser tilgjengelige",
    "search": "Søk valuta",
    "yczc": "Skjul eiendeler med verdi 0"
  },
  "td": {
    "drecord": "Ordreopptegnelser",
    "orecord": "Fullførte ordreopptegnelser",
    "filter": "Filtrer",
    "tdtype": "Handelstype",
    "buy": "Kjøp",
    "sell": "Selg",
    "wantbuy": "Ønske om kjøp",
    "dstatus": "Ordrestatus",
    "nofinish": "Ikke fullført",
    "finished": "Fullført",
    "ceiled": "Avbrutt",
    "payed": "Betalt",
    "waitPay": "Venter på betaling",
    "reset": "Tilbakestill",
    "confirm": "Bekreft",
    "time": "Tid",
    "num": "Mengde",
    "tdtotal": "Total handelsbeløp",
    "call": "Kontakt motparten",
    "buyer": "Kjøper",
    "seller": "Selger",
    "Sprice": "Enhetspris",
    "price": "Pris",
    "ptime": "Bestillingstid",
    "cnum": "Referansenummer",
    "tdceil": "Avbryt handel",
    "sureReceive": "Bekreft mottak",
    "conPay": "Betalingsbekreftelse",
    "ppay": "Vennligst betal",
    "paynext": "Vennligst betal til følgende konto",
    "tdPrice": "Handelsenhetspris",
    "tdNum": "Handelsmengde",
    "payInfo": "Betalingsinformasjon",
    "accountInfo": "Kontoopplysninger",
    "receiver": "Mottaker",
    "open": "Bank",
    "pcnum": "Vennligst fyll ut referansenummeret ved overføring",
    "imPay": "Jeg har betalt, klikk for å bekrefte",
    "tdAttion": "Handelsvarsel",
    "odCeil": "Avbryt ordre",
    "at01": "Din overføring vil gå direkte til selgerens konto, de digitale eiendelene solgt av selgeren under handelen beskyttes av plattformen.",
    "at02": "Vennligst fullfør betalingen innen den angitte tiden, og klikk på 'Jeg har betalt', når selgeren bekrefter mottak, vil systemet overføre de digitale eiendelene til kontoen din.",
    "at03": "Hvis kjøperen avbryter bestillingen tre ganger samme dag, vil kjøpsfunksjonen bli begrenset for den dagen.",
    "sureImpay": "Vennligst bekreft at du har betalt selgeren",
    "badClick": "Ondsinnet klikk vil umiddelbart fryse kontoen",
    "notpay": "Jeg har ikke betalt motparten ennå",
    "sureDpay": "Vennligst bekreft at kjøperen har betalt deg",
    "sureCeil": "Bekreft avbryt handel",
    "notCeil": "Hvis du allerede har betalt selgeren, må du ikke avbryte handelen",
    "dover": "Bestillingen er fullført, kan ikke se betalingsinformasjon",
    "cover": "Bestillingen er avbrutt, kan ikke se betalingsinformasjon",
    "payFast": "Vennligst betal så raskt som mulig etter betalingsbekreftelse",
    "payClick": "Hvis du allerede har overført betaling til selgeren, vennligst klikk på knappen 'Jeg har betalt' nederst til høyre, ellers kan det føre til tap av midler.",
    "pwait": "Vennligst vent på at kjøperen betaler",
    "pwd": "Handelspassord",
    "ppwd": "Vennligst skriv inn handelspassord",
    "sure": "Bekreft",
    "alipay": "Alipay",
    "wechat": "WeChat",
    "bank": "Bankkort",
    "realName": "Ekte navn",
    "knum": "Kortnummer",
    "pprice": "Vennligst skriv inn enhetspris",
    "pnum": "Vennligst skriv inn mengde",
    "min": "Minimum handelsvolum",
    "pmin": "Vennligst skriv inn minimum handelsvolum",
    "max": "Maksimum handelsvolum",
    "pmax": "Vennligst skriv inn maksimum handelsvolum",
    "buyNum": "Kjøpsmengde",
    "currency": "Valuta",
    "pmethod": "Vennligst velg betalingsmetode",
    "choose": "Vennligst velg",
    "mysells": "Mine salg",
    "mybuys": "Mine kjøpsforespørsel",
    "pcoin": "Vennligst velg valutaenhet"
  },

"fat": {
    "mybuy": "Jeg vil kjøpe",
    "mysell": "Jeg vil selge",
    "ceil": "Avbryt",
    "buy": "Kjøp",
    "sell": "Selg",
    "forsell": "Salgsbehov",
    "forbuy": "Kjøpsbehov",
    "price": "Enhetspris",
    "bprice": "Kjøp etter pris",
    "bnum": "Kjøp etter mengde",
    "pbtotal": "Vennligst skriv inn totalbeløpet for fiat-valutaen du ønsker å kjøpe",
    "pstotal": "Vennligst skriv inn totalbeløpet for fiat-valutaen du ønsker å selge",
    "pbnum": "Vennligst skriv inn ønsket kjøpsmengde",
    "psnum": "Vennligst skriv inn ønsket salgsmengde",
    "allbuy": "Kjøp alt",
    "allsell": "Selg alt",
    "limit": "Grense",
    "tdtotal": "Total handelsbeløp",
    "autoceil": "Automatisk avbrytelse",
    "num": "Mengde",
    "submit": "Legg inn ordre",
    "pwd": "Handelspassord",
    "ppwd": "Vennligst skriv inn handelspassord",
    "sure": "Bekreft ordre",
    "reTime": "Verifisert selger | Registreringstid",
    "release": "Publiser",
    "allOrder": "Totalt antall ordrer",
    "dayOrder": "30-dagers ordrer",
    "overOrder": "Fullførte ordrer",
    "rate": "Fullføringsrate",
    "auPhone": "Mobilverifisering",
    "auName": "Identitetsverifisering",
    "auHigh": "Avansert verifisering",
    "sellLine": "Selg online",
    "buyLine": "Kjøp online",
    "myshop": "Min butikk",
    "mybalance": "Selger saldo"
  },
  "auth": {
    "bh": "Avvist",
    "bhr": "Din søknad ble avvist, grunnene er som følger:",
    "mycenter": "Personlig senter",
    "test": "Identitetsverifisering",
    "gotest": "Gå til verifisering",
    "testing": "Under vurdering",
    "tested": "Verifisert",
    "t1": "Verifisering kan øke uttaksgrensen",
    "t2": "Verifisering muliggjør C2C-handel",
    "t3": "Verifisering muliggjør fiat-handel",
    "name": "Navn",
    "account": "Konto",
    "number": "Dokumentnummer",
    "pname": "Vennligst skriv inn navn",
    "pnum": "Vennligst skriv inn dokumentnummer",
    "id_card_face": "Vennligst last opp forsiden av identitetskortet",
    "id_card_back": "Vennligst last opp baksiden av identitetskortet",
    "upimg": "Vennligst last opp både forsiden og baksiden av dokumentet, samt et bilde av deg som holder dokumentet.",
    "updata": "Send inn",
    "updata_again": "Send inn på nytt"
  },
  "code": {
    "mycode": "Min promotorkode",
    "code": "Promotorkode",
    "qrcode": "Skann QR-koden ovenfor eller skriv inn promotorkoden for å bekrefte registreringen",
    "notice": "Kunngjøring",
    "about": "Relaterte nyheter"
  },
  "safe": {
    "title": "Kontosikkerhet",
    "center": "Sikkerhetssenter",
    "qchc": "Tøm cache",
    "yysz": "Språkinnstillinger",
    "ssms": "Mørk modus",
    "gywm": "Om oss",
    "lgpwd": "Innloggingspassord",
    "tkmm": "Uttakspassord",
    "paypwd": "Betalingspassord",
    "resetpwd": "Endre passord",
    "paccount": "Vennligst skriv inn mobilnummer eller e-post",
    "next": "Neste steg",
    "reset": "Endre",
    "stest": "Sikkerhetsverifisering",
    "ceil": "Avbryt",
    "pcode": "Vennligst skriv inn bekreftelseskode",
    "send": "Send",
    "sure": "Bekreft",
    "newPwd": "Tilbakestill passord",
    "len": "Passordet må være 6-20 tegn",
    "ppwd": "Vennligst skriv inn passord",
    "reppwd": "Vennligst skriv inn passordet på nytt",
    "repwd": "Tilbakestill passord",
    "zpwd": "Handelspassord"
  },
  "met": {
    "add": "Legg til metode",
    "open": "Banknavn",
    "bank": "Bankkonto",
    "realname": "Ekte navn",
    "alipay": "Alipay-konto",
    "wename": "WeChat-nickname",
    "wechat": "WeChat-konto",
    "save": "Lagre",
    "popen": "Vennligst skriv inn banknavn",
    "pbank": "Vennligst skriv inn bankkontonummer",
    "pname": "Vennligst skriv inn ekte navn",
    "palipay": "Vennligst skriv inn Alipay-konto",
    "pwename": "Vennligst skriv inn WeChat-nickname",
    "pweaccount": "Vennligst skriv inn WeChat-konto"
  },
  "ads": {
    "tas": "Uttaksadresse",
    "address": "Adresse",
    "noads": "Du har ingen adresser",
    "adds": "Adresser",
    "padd": "Skriv inn eller lim inn uttaksadresse",
    "remark": "Merknad",
    "cel": "Slett"
  },
  "call": {
    "callme": "Kontakt oss",
    "Privacy": "Personvernpolitikk"
  },
  "jc": {
    "title": "JC poeng bytte BEAU plattform",
    "bind": "Bind konto",
    "balance": "JC saldo",
    "cannum": "Tilgjengelig JC mengde:",
    "new": "BEAU siste pris:",
    "exnum": "Byttemengde:",
    "pnum": "Vennligst skriv inn JC mengde",
    "canex": "Kan bytte BEAU mengde:≈",
    "exnow": "Bytt nå",
    "record": "Bytteopptegnelser",
    "exprice": "Byttepris:",
    "extime": "Byttetid",
    "not": "Utilstrekkelig tilgjengelig poeng",
    "usenum": "Bruk JC mengde",
    "paccount": "Vennligst skriv inn konto",
    "ppwd": "Vennligst skriv inn passord",
    "gotd": "Gå til handel"
  },
  "lg": {
    "welcome": "Hei! Velkommen til innlogging",
    "hsa": "Har du allerede en konto?",
    "lgs": "Logg inn",
    "lgbt": "Logg inn",
    "lgtel": "Mobilinnlogging",
    "lgeml": "E-postinnlogging",
    "paccount": "Mobilnummer eller e-post",
    "ppwd": "Vennligst skriv inn passord",
    "ppwd2": "Vennligst bekreft passord",
    "pcode": "Vennligst skriv inn bekreftelseskode",
    "qsryqm": "Vennligst skriv inn invitasjonskode",
    "mepwd": "Husk passord",
    "noaccount": "Har du ikke en konto?",
    "qregister": "Gå til registrering",
    "register": "Registrer",
    "phregister": "Mobilregistrering",
    "emregister": "E-postregistrering",
    "noset": "Kan ikke endres etter registrering",
    "pphone": "Vennligst skriv inn mobilnummer",
    "next": "Neste steg",
    "have": "Har du allerede en konto?",
    "ceil": "Avbryt",
    "msgtest": "SMS-verifisering",
    "send": "Få bekreftelseskode",
    "sure": "Bekreft",
    "email": "Vennligst skriv inn e-postadresse",
    "emtest": "E-postverifisering",
    "scode": "Send bekreftelseskode",
    "pemcode": "Vennligst skriv inn bekreftelseskode",
    "ppcode": "Vennligst skriv inn mobilbekreftelseskode",
    "ftpwd": "Glemt passord?",
    "ftpwds": "Glemt passord",
    "ptext": "Vennligst skriv inn mobilnummer eller e-post",
    "safetest": "Sikkerhetsverifisering",
    "sjh": "Mobilnummer",
    "yzm": "Bekreftelseskode",
    "mm": "Passord",
    "qrmm": "Bekreft passord",
    "mmcd": "Passordlengde 8-12 tegn",
    "language": "Språkbytte",
    "kjzc": "Kontakt kundeservice for rask registrering",
    "kjzc1": "Kan ikke motta bekreftelseskode?",
    "kjzc2": "Rask registrering",
    "wyzx": "Jeg er klar over dette",
    "qtxyxzh": "Tips: Vennligst skriv inn en gyldig e-postadresse eller mobilnummer, som kan brukes til å tilbakestille passord",
    "symncz": "Bruk simuleringskonto for operasjoner"
  },
  "gjrz": {
    "title": "Avansert verifisering",
    "t1": "1. Støtter bilder i JPG, JPEG eller PNG format mindre enn 8M.",
    "t2": "2. Dokumentfoto må være klart, uten endringer eller skjul, må vise ansikt, dokumentnummer og navn.",
    "t3": "3. Foto skal være uten hat, anbefales uten sminke, ansiktet til dokumentinnehaveren må være klart synlig, med armene fullt synlige.",
    "t4": "Bekreft",
    "bh": "Avvist",
    "shz": "Under vurdering",
    "shtg": "Godkjent",
    "nyrzcg": "Du har blitt verifisert",
    "sczjz": "Last opp dokumentfoto",
    "sczjzmz": "Last opp dokumentets forside",
    "sczjbmz": "Last opp dokumentets bakside",
    "scgrqmz": "Last opp bilde av deg som holder dokumentet"
  },
"chongzhi": {
    "title": "Innskudd",
    "cbjl": "Innskuddsopptegnelser",
    "t1": "Mengde",
    "t2": "Vennligst skriv inn mengde",
    "t3": "Beskrivelse av bevis (valgfritt)",
    "t4": "Vennligst skriv inn beskrivelse",
    "t5": "Bevisbilde",
    "t6": "Bekreft",
    "t7": "Kjedenavn",
    "t8": "QR-kode",
    "t9": "Lagre QR-kode",
    "t10": "Innskuddsadresse",
    "t11": "Kopier",
    "zy": "Merk",
    "tips1": "Vennligst ikke innskudd noen ikke-tilknyttede eiendeler til ovennevnte adresse, ellers vil eiendelene ikke kunne gjenopprettes",
    "tips2": "1. Lommebok/plattformens kompatibilitet: dvs. støtte for dette nettverket; hvis målplattformen ikke støtter din uttaksnettverk, vil eiendelene ikke kunne gjenopprettes.",
    "tips3": "2. Innskuddsnettverket ditt må være det samme som målplattformen; hvis du velger måladresse på Ethereum-nettverket, men innskuddet er valgt på TRC20 smartkjede, kan du muligens ikke gjenopprette dine digitale eiendeler.",
    "tips4": "3. Før innskudd, sørg for at adressen og beløpet er korrekte.",
    "tips5": "Vennlig påminnelse: På grunn av blokknettverks anonymitet og konfidensialitet, vil du miste tilsvarende eiendeler hvis feil informasjon blir tastet. Vennligst sjekk innskuddsadresse og beløp nøye."
  },
  "tibi": {
    "title": "Uttak",
    "tbjl": "Uttaksopptegnelser",
    "t1": "Uttaksadresse",
    "t2": "Vennligst skriv inn uttaksadresse",
    "t3": "Uttaksmengde",
    "qsrtbsl": "Vennligst skriv inn uttaksmengde",
    "t4": "Minimum uttak",
    "t5": "Handelspassord",
    "t6": "Vennligst skriv inn handelspassord",
    "t7": "Gebyr",
    "t8": "Beløp som kommer frem",
    "t9": "Bekreft",
    "sc": "Slett",
    "bj": "Rediger",
    "bq": "Merkelapp (Memo)",
    "qsrbq": "Vennligst skriv inn merkelapp",
    "yhktx": "Bankkortuttak",
    "yhmc": "Banknavn",
    "qsryhmc": "Vennligst skriv inn banknavn",
    "yhzh": "Bankkonto",
    "qsryhzh": "Vennligst skriv inn bankkonto",
    "gjhkdm": "Internasjonal overføringskode",
    "qsrgjhkdm": "Vennligst skriv inn internasjonal overføringskode",
    "yhdz": "Bankadresse",
    "qsryhdz": "Vennligst skriv inn bankadresse",
    "skrxm": "Mottakers navn",
    "qsrskrxm": "Vennligst skriv inn mottakers navn",
    "skrdh": "Mottakers telefon",
    "qsrskrdh": "Vennligst skriv inn mottakers telefon",
    "skrdz": "Mottakers adresse",
    "qsrskrdz": "Vennligst skriv inn mottakers adresse"
  },
  "huazhuan": {
    "title": "USDT overføring",
    "t1": "Valutakonto saldo",
    "t2": "Kontraktskonto saldo",
    "t3": "Overføringsmengde",
    "t4": "Vennligst skriv inn mengde",
    "t5": "Overføringsretning",
    "t6": "Fra",
    "t7": "Valutakonto",
    "t8": "Til",
    "t9": "Kontraktskonto",
    "t10": "Bekreft",
    "zf": "Betal",
    "ky": "Tilgjengelig",
    "dd": "Få",
    "qbdh": "Bytt alt"
  },
  "banner": {
    "title": "Detaljer"
  },
  "download": {
    "t1": "Mobilhandel, når som helst, hvor som helst",
    "xz": "Last ned"
  },
  "xgdlmm": {
    "title": "Endre innloggingspassord",
    "zh": "Konto",
    "zhts": "Mobilnummer eller e-post",
    "yzm": "Bekreftelseskode",
    "yzmts": "Vennligst skriv inn bekreftelseskode",
    "hqyzm": "Få bekreftelseskode",
    "mm": "Passord",
    "mmts": "Passordlengde 6-12 tegn",
    "qrmm": "Bekreft passord",
    "send": "Send",
    "qr": "Bekreft"
  },
 "sztkmm": {
    "title": "Sett handelspassord",
    "dlmm": "Innloggingspassord",
    "dlmmts": "Vennligst skriv inn innloggingspassord",
    "xmm": "Nytt passord",
    "mmts": "Passordlengde 6 sifre",
    "qrmm": "Bekreft passord",
    "qr": "Bekreft",
    "qd": "Bekreft",
    "sztkts": "Tips: Vennligst gå til sikkerhetssenteret for å sette handelspassord"
  },
  "rule": {
    "title": "Aktivitetsregler",
    "title2": "Regler",
    "title3": "Aktivitet"
  },
  "news": {
    "title": "Mine meldinger",
    "ckxq": "Se detaljer",
    "gg": "Kunngjøring"
  },
  "xsbk": {
    "title": "Nybegynnere må lese"
  },
  "search": {
    "qx": "Avbryt",
    "rmss": "Populære søk",
    "ss": "Søk"
  },
  "wdtg": {
    "title": "Venner samles",
    "yq": "Inviter",
    "zyj": "Tjen kommisjon",
    "wdyqlj": "Min invitasjonslenke",
    "wdyqm": "Min invitasjonskode",
    "schbyq": "Generer plakatinvitasjon",
    "ljtgsy": "Total promotering inntekt",
    "ljkh": "Totalt antall kunder (personer)",
    "tkrs": "Antall inviterte",
    "ljyj": "Total kommisjon",
    "yjmx": "Kommisjonsdetaljer",
    "ljyjjl": "Total kommisjonsbelønning (USDT)",
    "ljsy": "Total inntekt",
    "ljyqjl": "Total invitasjonsbelønning (USDT)",
    "fxd": "Del med",
    "wxhy": "WeChat-venner",
    "wxpyq": "WeChat-vennegruppe",
    "bctp": "Lagre bilde",
    "qx": "Avbryt",
    "t1": "Grav samtidig mens du kopierer valuta",
    "t2": "Alt overskudd går til deg",
    "t3": "Hold nede for å skanne eller skann QR-koden"
  },
  "bzhl": {
    "title": "Økonomistyring",
    "gz": "Regler",
    "tgdd": "Forvaltningsordrer",
    "zztgdzj": "Midler under forvaltning",
    "yjjrsy": "Estimert daglig avkastning",
    "ljsy": "Total avkastning",
    "tgzdd": "Ordrer under forvaltning",
    "cljxcp": "Strategi konkurranseprodukter",
    "dbxe": "Maksimumsbeløp per transaksjon",
    "rsyl": "Daglig avkastningsrate",
    "zq": "Periode",
    "qmr": "Kjøp nå",
    "bbzhzc": "Kontoeiendeler",
    "zcc": "Total beholdning (USDT)",
    "dd": "Ordre",
    "buy": "Kjøp",
    "jxcp": "Utvalgte produkter",
    "ckdd": "Se ordre",
    "gd": "Mer",
    "xzbzts": "Enkelt, sikkert. Kan velge flere valutaer for utbetaling",
    "qtbz": "Andre valutaer"
  },
  "bzhlgm": {
    "title": "Arbitrageprofitt",
    "bzhld": "Arbitrageprofitt i USDT",
    "qtzq": "USDT 7-dagers periode",
    "rsyl": "Avkastningsrate (%)",
    "lczq": "Investeringsperiode",
    "dbxe": "Maksimumsbeløp per transaksjon",
    "pxsj": "Utbetalingsperiode",
    "mr": "Daglig",
    "dqfh": "Tilbakebetaling ved forfall",
    "tgzj": "Forvaltede midler",
    "tqsh": "Innløsning",
    "yjsy": "Estimert avkastning (USDT)",
    "kyzc": "Tilgjengelige eiendeler (USDT)",
    "cpjs": "Produktbeskrivelse",
    "tgje": "Forvaltningsbeløp",
    "qsrtgje": "Vennligst skriv inn forvaltningsbeløp",
    "qb": "Alle",
    "rm": "Kjøp nå",
    "cpzq": "Produktperiode",
    "jxr": "Renteperiode",
    "jiexr": "Avregningsdag",
    "yjdzr": "Estimert dato for overføring",
    "gz": "Forstå regler og rettigheter"
  },
  "bzhlwdtg": {
    "title": "Ordrestatus",
    "tgz": "Under forvaltning",
    "ywc": "Fullført",
    "ysh": "Innløst",
    "tgje": "Forvaltningsbeløp / periode dager",
    "rsyl": "Daglig avkastningsrate",
    "yhl": "Allerede tjent / gjenværende dager",
    "xdsj": "Bestillingstid",
    "sh": "Innløsning",
    "ddxq": "Ordredetaljer",
    "ddh": "Ordrenummer"
  },
  "bzjj": {
    "t1": "Tjen penger hver dag",
    "t2": "Arbitrage innebærer å overføre USDT til plattformen, der plattformens fagteam utfører arbitrage-rettigheter, deltakere kan motta en andel av plattformens arbitrageinntekter i løpet av forvaltningstiden.",
    "cpld": "Produktegenskaper",
    "scsq": "Fritt innskudd og uttak",
    "pxzq": "Utbetalingssyklus",
    "mtxf": "Daglig utbetaling",
    "hqlx": "Rente på innskudd",
    "zj": "100% midler",
    "aqbz": "Sikkerhetsgaranti",
    "jjrsy": "Helligdagsavkastning",
    "sybjd": "Uavbrutt avkastning",
    "bjd": "Uavbrutt",
    "cgcrh": "Etter vellykket innskudd",
    "dtqx": "Renter begynner samme dag",
    "jglz": "La meg gi et eksempel",
    "syjs": "Avkastningsberegning",
    "cont1": "Medlemmer setter inn 10000U på plattformen, velger en periode på syv dager, med en daglig avkastningsrate på 0,3%~0,5%, vil den daglige avkastningen være som følger:",
    "cont2": "Minimum: 10000U × 0,3% - 30U",
    "cont3": "Maksimum: 10000U × 0,5% - 50U",
    "cont4": "Det vil si: Etter 7 dager kan du få 210U - 350U i avkastning, avkastningen utbetales daglig, og den utbetalte avkastningen kan tas ut når som helst, og det innskutte beløpet vil automatisk returneres til din lommebok etter at perioden er over.",
    "gywyj": "Om bruddgebyrer",
    "cont5": "Hvis du ønsker å ta ut ikke-moden hovedstol, vil det påløpe bruddgebyr, bruddgebyr = bruddreguleringsprosent * gjenværende dager * investeringsbeløp.",
    "cont6": "Eksempel: Bruddreguleringsprosenten for dette produktet er 0,4%, det er 3 dager igjen til forfall, investeringsbeløpet er 1000, så bruddgebyret = 0,4% * 3 * 1000 = 12U, det faktiske tilbakebetalte beløpet er 1000U - 12U = 988U.",
    "wycy": "Jeg vil delta"
  },
  "zyzs": {
    "title": "Take profit og stop loss",
    "zy": "Take profit",
    "zs": "Stop loss",
    "qsrzyjg": "Vennligst skriv inn take profit pris",
    "qsrzsjg": "Vennligst skriv inn stop loss pris",
    "cfjglx": "Utløsningspristype:",
    "zsjg": "Indekspris",
    "scjg": "Markedspris",
    "pcfs": "Lukkingsmetode:",
    "kpcw": "Tilgjengelige posisjoner",
    "qbcw": "Alle posisjoner",
    "wxts": "Vennlig påminnelse:",
    "cont": "Markedslukkingen kan mislykkes på grunn av kraftige markedsbevegelser, noe som kan forhindre vellykket take profit eller stop loss.",
    "qr": "Bekreft"
  },
 "bbjy": {
    "mr": "Kjøp",
    "mc": "Selg",
    "mai": "Kjøp",
    "sell": "Selg",
    "xj": "Grensepris",
    "sj": "Markedspris",
    "pk": "Marked",
    "jg": "Pris",
    "sl": "Mengde",
    "mrl": "Kjøpsmengde",
    "ss": "Mengde",
    "mcl": "Salgsvolum",
    "ky": "Tilgjengelig",
    "km": "Kan kjøpes",
    "ksell": "Kan selges",
    "jye": "Handelsbeløp",
    "dqwt": "Nåværende",
    "lswt": "Historie",
    "jj": "Introduksjon",
    "wtzl": "Total ordre",
    "wtjg": "Ordrepris",
    "ycjl": "Allerede handlet volum",
    "cjjj": "Gjennomsnittlig handelspris",
    "cd": "Avbryt ordre",
    "xd": "Legg inn ordre",
    "ywc": "Fullført",
    "ycd": "Avbrutt",
    "wqcj": "Fullført handel",
    "zx": "Favoritter",
    "scjg": "Markedspris",
    "fhsj": "Utgivelsestid",
    "fhsl": "Utgivelsesvolum",
    "bps": "Whitepaper",
    "gw": "Offisiell nettside",
    "qx": "Avbryt"
  },
  "hyjy": {
    "mai": "Kjøp",
    "sell": "Selg",
    "kc": "Åpne posisjon",
    "pc": "Lukke posisjon",
    "cc": "Beholdning",
    "kp": "Kan lukkes",
    "kpc": "Kan lukkes kort",
    "kcc": "Kan beholdes",
    "kkd": "Kan åpnes lang",
    "kpd": "Kan lukkes lang",
    "kkk": "Kan åpnes kort",
    "xj": "Grensepris",
    "sj": "Markedspris",
    "xjwt": "Grenseordre",
    "sjwt": "Markedsordre",
    "pk": "Marked",
    "jg": "Pris",
    "sl": "Mengde",
    "gg": "Giring",
    "tzgg": "Juster giring",
    "ggbs": "Giringstall",
    "mrl": "Kjøpsmengde",
    "ky": "Tilgjengelig",
    "jye": "Handelsbeløp",
    "dqwt": "Nåværende oppdrag",
    "lswt": "Historiske oppdrag",
    "ptwt": "Vanlig ordre",
    "dqwtmr": "Nåværende oppdrag (Kjøp)",
    "dqwtmc": "Nåværende oppdrag (Selg)",
    "hywt": "Kontraktordre",
    "jj": "Introduksjon",
    "wtzl": "Total ordre",
    "wtjg": "Ordrepris",
    "ycjl": "Allerede handlet volum",
    "cjjj": "Gjennomsnittlig handelspris",
    "cd": "Avbryt ordre",
    "xd": "Legg inn ordre",
    "qbcd": "Avbryt alle ordre",
    "wqcj": "Fullført handel",
    "ywc": "Fullført",
    "ycd": "Avbrutt",
    "zx": "Favoritter",
    "scjg": "Markedspris",
    "fhsj": "Utgivelsestid",
    "fhsl": "Utgivelsesvolum",
    "bps": "Whitepaper",
    "gw": "Offisiell nettside",
    "mrzd": "Kjøp lang",
    "mrpk": "Kjøp kort",
    "mczk": "Selg kort",
    "mcpd": "Selg lang",
    "mrkdkz": "Kjøp lang (bull)",
    "mrpkkz": "Kjøp kort (bull)",
    "mckkkd": "Selg kort (bear)",
    "mcpdkd": "Selg lang (bear)",
    "yxhy": "Evig kontrakt",
    "dc": "Lang posisjon",
    "kcjj": "Åpningspris (BUSDT)",
    "wsxyl": "Urealiserte gevinster (BUSDT)",
    "ygqpj": "Estimert sterk vurdering (BUSDT)",
    "syl": "Avkastningsrate",
    "cwbzj": "Margin for posisjon (BUSDT)",
    "cw": "Posisjon (hånd)",
    "cwjz": "Posisjonsverdi (BUSDT)",
    "bzjl": "Marginrate",
    "kpz": "Kan lukkes (hånd)",
    "bdzs": "Indeks",
    "tzbzj": "Juster margin",
    "zyzs": "Take profit og stop loss",
    "zjbzj": "Øk margin",
    "jsbzj": "Reduser margin",
    "tyhy": "Prøv kontrakt",
    "ccz": "Posisjon (hånd)",
    "cwbzjt": "Margin for posisjon (TBTC)",
    "zdzjbzj": "Maksimal økning av margin (TBTC)",
    "zjbzjt": "Øk margin (TBTC)",
    "zhang": "Mengde",
    "qblx": "Alle typer",
    "qb": "Alle",
    "ccjg": "Posisjonspris",
    "ccsl": "Posisjonsmengde",
    "yk": "Gevinst/tap",
    "ccsj": "Posisjonstid",
    "zy": "Take profit",
    "zs": "Stop loss",
    "zje": "Totalbeløp",
    "kcs": "Åpningsmengde",
    "kcjg": "Åpningspris",
    "ss": "Hånd",
    "hand": "1 hånd =",
    "qx": "Avbryt",
    "qr": "Bekreft"
  },
  "kxt": {
    "gao": "Høy",
    "di": "Lav",
    "wtgd": "Ordrebestilling",
    "cj": "Fullført",
    "jj": "Introduksjon",
    "sj": "Tid",
    "fx": "Retning",
    "jg": "Pris",
    "sl": "Mengde",
    "mr": "Kjøp",
    "mc": "Selg",
    "mp": "Kjøpsside",
    "sp": "Salgs side",
    "slb": "Mengde",
    "fhsj": "Utgivelsestid",
    "fhsl": "Utgivelsesvolum",
    "bps": "Whitepaper",
    "gw": "Offisiell nettside",
    "fz": "min",
    "xs": "time",
    "tian": "dag",
    "zhou": "uke",
    "yue": "måned",
    "gd": "Mer",
    "ft": "Sekundærdiagram",
    "zt": "Hoveddiagram",
    "sdt": "Dybde diagram",
    "zx": "Favoritter",
    "djck": "Klikk for å se"
  },
  "zhjl": {
    "cbtb": "Innskudd og uttak",
    "jymx": "Handeldetaljer",
    "tgyj": "Promotert kommisjon",
    "wwc": "Ikke fullført",
    "ywc": "Fullført"
  },
"zwsj": {
    "title": "Ingen data tilgjengelig"
  },
  "bzxz": {
    "title": "Velg valuta"
  },
  "jghy": {
    "jghy": "Leveringskontrakt",
    "yxhy": "Evig kontrakt",
    "mz": "Kjøp opp",
    "md": "Kjøp ned",
    "gmj": "Kjøpspris",
    "jsj": "Avregningspris",
    "xj": "Nåværende pris",
    "fx": "Retning",
    "sl": "Mengde",
    "jgsj": "Leveringstid",
    "gb": "Lukk",
    "jxxd": "Fortsett å legge inn ordre",
    "cclb": "Beholdningsliste",
    "zc": "I beholdning",
    "lscc": "Historisk beholdning",
    "qblx": "Alle typer",
    "yk": "Gevinst/tap",
    "ddqr": "Ordrebekreftelse",
    "dqsj": "Forfallsdato",
    "jssj": "Avregningstid",
    "sy": "Avkastning",
    "tzje": "Investeringsbeløp",
    "zdje": "Investeringsbeløp må være større enn 0",
    "kyye": "Tilgjengelig saldo:",
    "kyye2": "Tilgjengelig saldo",
    "sxf": "Gebyr:",
    "sxfl": "Gebyr",
    "jypz": "Navn",
    "jyfx": "Handelsretning",
    "qrxd": "Bekreft ordre",
    "fs": "Mer",
    "dqye": "Nåværende saldo"
  },
  "kjmb": {
    "title": "Kjøp mynter",
    "gm": "Kjøp USDT",
    "wxts": "Vennlig påminnelse:",
    "wxts-copy": "Vennligst kopier USDT-adressen, du må bruke denne adressen for å kjøpe USDT.",
    "copy": "Kopier",
    "ljmb": "Kjøp valuta nå",
    "buy": "Kjøp",
    "cs": "Selg",
    "qx": "Avbryt",
    "gmsl": "Kjøpsmengde",
    "cssl": "Salgsvolum",
    "qsrgmsl": "Vennligst skriv inn kjøpsmengde",
    "qsrcssl": "Vennligst skriv inn salgsvolum",
    "qxzzffs": "Vennligst velg betalingsmetode",
    "yhk": "Bankkort",
    "wx": "WeChat",
    "zfb": "Alipay",
    "jg": "Pris",
    "kyye": "Tilgjengelig saldo:",
    "zxjysl": "Minimum handelsmengde:",
    "ts1": "1. Kjøpere og selgere er plattformverifiserte selgere som tilbyr 24-timers service.",
    "ts2": "2. Hvis det oppstår tvister om ordren, vennligst kontakt kundeservice umiddelbart.",
    "fzcg": "Kopiering vellykket"
  },
  "tips": {
    "jymm": "Handelspassord",
    "szjymm": "Sett handelspassord",
    "qsrjymm": "Vennligst skriv inn handelspassord",
    "jymmts": "Vennligst gå til sikkerhetssenteret for å sette handelspassord"
  },
  "xyf": {
    "title": "Kredittpoeng",
    "pgsj": "Vurderingstid"
  },
  "dzrz": {
    "title": "Adresseverifisering",
    "sdddz": "Vann- og strømregning adresse",
    "tips": "Du må fylle ut adresseinformasjon og sende inn regning for vann eller strøm, eller bredbånd.",
    "tpsc": "Last opp regning bilde",
    "ts": "Tips: Du må fylle ut adresseinformasjon og sende inn regning for vann eller strøm, eller bredbånd.",
    "qsczdtp": "Vennligst last opp regning bilde"
  },
  "newReg": {
    "sjh": "Mobilnummer",
    "yx": "E-post",
    "yqm": "Invitasjonskode",
    "yqm2": "Invitasjonskode (valgfritt)",
    "cjzh": "Opprett konto",
    "sysjhzyx": "Registrer med mobilnummer/e-post",
    "sj": "Mobil",
    "yhxy": "《Brukeravtale》",
    "yhxy2": "Jeg har lest og godtar 《Brukeravtale》"
  },
 "mbwt": {
    "title": "Sikkerhetsspørsmålinnstillinger",
    "mbwt": "Sikkerhetsspørsmål",
    "qtxda": "Vennligst fyll ut svaret",
    "qsrxmm": "Vennligst skriv inn nytt passord",
    "sydqmmcz": "Bruk nåværende passord for å tilbakestille",
    "zhmm": "Sikkerhetsspørsmål for tilbakestilling av passord",
    "ysz": "Allerede satt",
    "tg": "Hopp over",
    "tj": "Send inn",
    "zyts": "Viktig påminnelse:",
    "zytsCont": "Vennligst ikke avslør svarene på sikkerhetsspørsmålene og bekreftelseskoden, og husk sikkerhetsspørsmålene, da dette vil hjelpe deg med å tilbakestille passordet."
  },
  "xbsg": {
    "title": "Ny mynt",
    "wdsg": "Mine forhåndsbestillinger",
    "scts": "Låste dager:",
    "sy": "Gjenstående",
    "ljsg": "Bestill nå",
    "ysk": "Utsolgt",
    "xzjdy": "Abonner nå",
    "dy": "Abonner",
    "fxjg": "Utgivelsespris",
    "fxl": "Utgivelsesvolum",
    "ssrq": "Noteringsdato",
    "yxqx": "Gyldighetsperiode",
    "qsrsl": "Vennligst skriv inn mengde",
    "syl": "Gjenstående mengde",
    "sgrq": "Bestillingsdato",
    "sgsl": "Bestillingsmengde",
    "bz": "Valuta",
    "yebz": "USDT-saldo utilstrekkelig",
    "tgsl": "Gjennom mengde",
    "shz": "Under vurdering",
    "wtg": "Ikke godkjent",
    "ytg": "Godkjent"
  },
  "wydb": {
    "title": "Jeg vil låne",
    "db": "Låne",
    "dbz": "Låner",
    "jl": "Opptegnelse",
    "jdzq": "Låneperiode (dager)",
    "qhk": "Gå til tilbakebetaling",
    "ljdb": "Total lån (USDT)",
    "dhkbs": "Antall lån som skal tilbakebetales",
    "jkje": "Lånebeløp (USDT)",
    "qsrje": "Vennligst skriv inn beløp",
    "rll": "Daglig rente",
    "hkfs": "Tilbakebetalingsmetode",
    "dqych": "Tilbakebetaling av hovedstol og renter ved forfall",
    "lx": "Rente",
    "fkjg": "Utbetalingsinstitusjon",
    "tpsc": "Kredittlån (bildeopplasting)",
    "fwxx": "Boliginformasjon",
    "srzm": "Inntektsbevis (ansettelsesforhold)",
    "yhmx": "Bankdetaljer",
    "zjz": "Identitetsbilde",
    "yd": "Jeg har lest og godtar",
    "xy": "Søknad om lån avtale",
    "sqdb": "Klikk for å søke om lån",
    "gb": "Lukk",
    "qd": "Bekreft",
    "ts": "Vennligst merk av for søknad om lån avtale",
    "dbjl": "Låneopptegnelser",
    "hkhth": "Lånekontraktsnummer",
    "wsh": "Ikke vurdert",
    "yfk": "Lånt ut",
    "sqrq": "Søknadsdato",
    "zq": "Periode",
    "dbsl": "Lånemengde",
    "zhke": "Total tilbakebetalingsbeløp",
    "yhkxq": "Detaljer om tilbakebetaling",
    "bqyhk": "Denne perioden skal tilbakebetales (USDT)",
    "hktips": "Vennligst sørg for at saldoen er tilstrekkelig, hvis saldoen er utilstrekkelig, vennligst fyll på før du tilbakebetaler",
    "bj": "Hovedstol",
    "jie": "Låne",
    "ljhk": "Tilbakebetal umiddelbart",
    "qcz": "Gå til innskudd",
    "yebzqxcz": "Saldo utilstrekkelig, vennligst fyll på før tilbakebetaling",
    "znj": "Forsinkelsesgebyr",
    "yqts": "Forsinkelsesdager"
  },
  "hkxq": {
    "dd": "Ordre",
    "fzhkdz": "Kopier tilbakebetalingsadresse",
    "hkxq": "Detaljer om tilbakebetaling",
    "zlx": "Total rente",
    "zhk": "Total tilbakebetaling",
    "hkjg": "Tilbakebetalingsinstitusjon",
    "qschkpz": "Vennligst last opp tilbakebetalingsbevis",
    "hkpz": "Tilbakebetalingsbevis"
  },
  "bbjyNew": {
    "jylx": "Handelstype",
    "jyze": "Total handelsbeløp"
  },
  "indexNew": {
    "title": "Legg til TokenSwap til hovedskjermen",
    "t1": "Rask tilgang, fullskjermopplevelse",
    "t2": "Klikk på verktøylinjen nedenfor",
    "t3": "og velg",
    "t4": "Legg til på hovedskjerm",
    "t5": "Legg til skrivebordsopplevelse av TokenSwap",
    "t6": "Legg til i personlige favoritter",
    "t7": "Finn på siden"
  },
  "bind": {
    "title": "E-postverifisering",
    "ybd": "Allerede bundet",
    "wbd": "Ikke bundet",
    "yrz": "Allerede verifisert",
    "wrz": "Ikke verifisert",
    "ts": "For å beskytte kontoen din, anbefales det å binde e-post",
    "qsryxdz": "Vennligst skriv inn e-postadresse"
  },
  "status": {
    "statusText": ["Feil", "Venter på behandling", "Suksess"]
  },
  "tipsNew": {
    "wjmmts": "Tilbakestill passord via bekreftelseskode",
    "qscpztp": "Vennligst last opp bevisbilde",
    "emailgsts": "Den angitte e-posten er ikke i samsvar med reglene",
    "telgsts": "Det angitte mobilnummeret har feil format",
    "lcmmbyz": "De to passordene samsvarer ikke",
    "zdsl": "laveste",
    "sldydy": "Mengde må være større enn eller lik",
    "zxtzsl": "laveste",
    "ddz": "Venter",
    "xs": "Timer",
    "min": "Minimumsbeløp",
    "max": "Maksimumsbeløp",
    "yebz": "Saldo utilstrekkelig",
    "qsrss": "Vennligst skriv inn hånd",
    "zdss": "Minimumsantall",
    "yjj": "Avvist",
    "shz": "Innløsning pågår",
    "zwkfcz": "Denne valutaen har ikke åpnet for innskudd",
    "jiaoge": "Levering",
    "zhang": "Oppgang",
    "die": "Nedgang",
    "cjxnzh": "Opprett virtuell konto"
  },
  "langNew2": {
    "flzq": "Fordelsområde",
    "qdjl": "Registreringsbelønning",
    "mrqdjl": "Daglig registreringsbelønning",
    "qd": "Registrer",
    "yqd": "Allerede registrert",
    "hdgz": "Aktivitetsregler",
    "qdjl2": "Registreringsopptegnelser",
    "qdcg": "Registrering vellykket",
    "yhd": "Allerede mottatt",
    "lq": "Motta",
    "dyt": "Første dag",
    "det": "Andre dag",
    "dst": "Tredje dag",
    "dsit": "Fjerde dag",
    "dwt": "Femte dag",
    "dlt": "Sjette dag",
    "dqt": "Syvende dag",
    "jxz": "Pågår"
  },
  "langNew": {
    "kp": "Åpne",
    "zuoshou": "Forrige lukking",
    "zg": "Høyeste",
    "zd": "Laveste",
    "dqjg": "Nåværende pris",
    "pcjg": "Lukkepris",
    "gd": "Ordre",
    "gdj": "Ordrepris",
    "gdjg": "Ordrepris",
    "xfbzj": "Må betales i margin:",
    "ksrfw": "Kan skrive inn område:",
    "shou": "Hånd",
    "fdjyk": "Flytende netto gevinst/tap",
    "pcsl": "Lukke mengde",
    "cx": "Avbryt",
    "qrpc": "Bekreft lukking",
    "sx": "Filtrer",
    "cz": "Tilbakestill",
    "zdl": "Forstått",
    "kccg": "Åpning vellykket!",
    "xzfx": "Velg retning",
    "lx": "Type",
    "xgcc": "Endre beholdning",
    "szzyzs": "Sett take profit og stop loss",
    "szhb": "Krypto",
    "gjs": "Edelmetaller",
    "yy": "Råolje",
    "jy": "Handel",
    "jmhb": "Kryptovaluta",
    "gdsj": "Ordretid",
    "gdsl": "Ordremengde",
    "fs": "Tid"
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/no.js